class RoulartaLogoSwitcher {
  constructor() {
    this.defaultLogo = null;
    this.zondagLogo = null;
    this.init();
  }

  init() {
    this.defaultLogo = document.querySelector('[data-logo-type="default"]');
    this.zondagLogo = document.querySelector('[data-logo-type="zondag"]');

    if (!this.defaultLogo || !this.zondagLogo) {
      return;
    }

    this.switchLogo();
  }

  switchLogo() {
    const urlParams = new URLSearchParams(window.location.search);
    const logoParam = urlParams.get('logo');

    if (logoParam === 'zondag') {
      this.defaultLogo.style.opacity = '0';
      this.zondagLogo.style.opacity = '1';
      return;
    }

    this.defaultLogo.style.opacity = '1';
    this.zondagLogo.style.opacity = '0';
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new RoulartaLogoSwitcher();
});
